// パスキー（WebAuthn）の関連付けドメイン。Cognito の WebAuthnConfiguration.RelyingPartyId と一致させること
export const PASSKEY_RP_ID = 'factime.jp';

// 現在のページでこのドメインのパスキーが使えるか（factime.jp / www.factime.jp）
export const isOnPasskeyDomain = () => {
  const host = window.location.hostname;
  return host === PASSKEY_RP_ID || host.endsWith(`.${PASSKEY_RP_ID}`);
};
